import {reqWithToken} from './requestHelper';

export async function getRooms(){
    return (await reqWithToken('api/gxbooking/classrooms')).data;
}

export async function getNcutRooms(){
    return (await reqWithToken('api/classrooms/ofGuoXiu')).data;
}

